// Writer Studio display-only numbering for Novel chapters.
// Canon sceneNumber remains book-wide history metadata and is NEVER rewritten.
// Chapter numbering follows the saved Chapter.sceneIds ordering.
export function displayedNovelSceneNumberV1(location = {}) {
  const hasChapter =
    Number.isInteger(location.chapterNumber) &&
    location.chapterNumber > 0;
  const number = hasChapter
    ? location.chapterSceneNumber
    : location.canonSceneNumber;
  return Number.isInteger(number) && number > 0 ? number : null;
}
